export default "__VITE_ASSET__Dc3miTR$__"